export const normalizeTranslations = (origTranslations) => {
    /* Replaces twine variables format %1$d to {{ 1 }} which is i18next.js compatible */
    const re = /%(\d)\$\S/g;
    for (let key in origTranslations) {
        origTranslations[key]= origTranslations[key].replace(re, '{{ $1 }}');
        origTranslations[key]= origTranslations[key].replace("%d", '{{ 1 }}');

    }
    return origTranslations;
};


// WEBPACK FOOTER //
// ./src/locales/utils.js